import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { useLink } from "@/hooks/useLink";
import sourceflowEnums from "@/sourceflow.enums";

export const RegisterPageFormSection = ({ className, pathPrefix }) => {
  const locale = useLocale();
  const link = useLink();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = link("careers.register.complete");
    }
  };

  return (
    <div className={className}>
      <Container>
        <div className={clsx(classes.form, "p-5")}>
          <DynamicText path={`${pathPrefix}.form.title.${locale}`} tag="h3" className="mb-4" />
          <Form formId={sourceflowEnums.forms.register.internal} onSubmitDone={onSubmitDone} />
        </div>
      </Container>
    </div>
  );
};

RegisterPageFormSection.defaultProps = {
  pathPrefix: "page.register",
};
